export default __webpack_public_path__ + "images/logoAvya.da9c4fa76d31905daa9c04a5af884b38.svg"